import { DEFAULT_NOTE_MAX_LENGTH } from '.'

export const selectSuggestionReasons = (store: any) => {
  return store?.suggestionReasons?.reasons ?? []
}

export const selectSuggestionReasonsRequested = (store: any) => {
  return store?.suggestionReasons?.requested ?? false
}

export const selectNoteMaxLength = (store: any) => {
  return store?.suggestionReasons?.maxLength ?? DEFAULT_NOTE_MAX_LENGTH
}
